'use client';

import usePageLoaded from '@/helpers/hooks/usePageLoaded';
import { useGetPopupQuery } from '@/store/api/popup';

import BeforeClosePopup from './BeforeClose';

export default function RegisterPopup() {
  const isPageFullyLoaded = usePageLoaded();
  const { data, isLoading, isError, isFetching } = useGetPopupQuery(undefined, {
    skip: !isPageFullyLoaded,
  });

  if (!data?.id) return <></>;

  const shouldRegisterPopup =
    !isLoading &&
    !isError &&
    !isFetching &&
    !!data?.id &&
    new Date(data?.StartDate) <= new Date() &&
    new Date(data?.EndDate) > new Date();

  if (!shouldRegisterPopup) return <></>;

  console.log('registering popup');
  return <BeforeClosePopup popup={data} />;
}
